/* tslint:disable */
/* eslint-disable */
/* @relayHash a8c613b3fec5759feefcff6ee03c960e */

import { ConcreteRequest } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MODERATOR" | "STAFF" | "UNANSWERED" | "%future added value";
export type FeatureCommentInput = {
    commentID: string;
    commentRevisionID: string;
    clientMutationId: string;
};
export type FeatureCommentMutationVariables = {
    input: FeatureCommentInput;
};
export type FeatureCommentMutationResponse = {
    readonly featureComment: {
        readonly comment: {
            readonly tags: ReadonlyArray<{
                readonly code: TAG;
            }>;
            readonly status: COMMENT_STATUS;
        } | null;
        readonly clientMutationId: string;
    };
};
export type FeatureCommentMutation = {
    readonly response: FeatureCommentMutationResponse;
    readonly variables: FeatureCommentMutationVariables;
};



/*
mutation FeatureCommentMutation(
  $input: FeatureCommentInput!
) {
  featureComment(input: $input) {
    comment {
      tags {
        code
      }
      status
      id
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "FeatureCommentMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "FeatureCommentPayload",
                    "kind": "LinkedField",
                    "name": "featureComment",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "comment",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "FeatureCommentMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "FeatureCommentPayload",
                    "kind": "LinkedField",
                    "name": "featureComment",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "comment",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "a8c613b3fec5759feefcff6ee03c960e",
            "metadata": {},
            "name": "FeatureCommentMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '1b2d02935eebc3842c8331874b816df0';
export default node;
